import styled from 'styled-components';

import VisuallyHidden from 'components/VisuallyHidden';
import colors from 'utils/colors';
import { textFocus } from 'utils/styled';

const checkIcon =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0yMCA2TDkgMTdsLTUtNSIvPjwvc3ZnPg==';

export const Wrapper = styled.div`
  width: 100%;
  padding-bottom: 15px;
`;

export const InputCheckbox = styled(VisuallyHidden).attrs({ as: 'input' })``;

export const Label = styled.label`
  display: block;
  position: relative;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  width: 100%;
  cursor: pointer;
  color: ${colors.blueGrey};

  /* Focus and Hover state */
  &:hover {
    ${textFocus};
  }

  /* Disabled state */
  ${InputCheckbox}[disabled] + & {
    cursor: not-allowed;
    pointer-events: none;
  }

  &::before {
    content: '';
    display: inline-block;
    margin-right: 12px;
    height: 16px;
    width: 16px;
    vertical-align: middle;
    background-color: ${colors.white};
    border: 1px solid ${colors.blueGrey};
  }
  &::after {
    content: '';
    position: absolute;
    opacity: 0;
    background-image: url(${checkIcon});
    background-repeat: no-repeat;
    height: 16px;
    width: 16px;
    left: 1px;
    top: 5px;
  }

  /* Checked state */
  ${InputCheckbox}:checked + &::before {
    background-color: ${colors.orange};
    border-color: ${colors.orange};
  }
  ${InputCheckbox}:checked:not([disabled]) + &::after {
    opacity: 1;
  }

  /* Error state */
  ${InputCheckbox}[aria-invalid='true']:not(:checked):not([disabled]) + &::before {
    border-color: ${colors.red};
  }

  /* Disabled state */
  ${InputCheckbox}[disabled] + &::before {
    background-color: ${colors.darkGrey10};
    border-color: ${colors.darkGrey75};
  }

  /* Focus state */
  ${InputCheckbox}:focus + &::before,
  ${InputCheckbox}:hover + &::before {
    border-color: ${colors.orange};
  }
`;
